import React from 'react';

import Icon from '../Icon/Icon';

const TroubleshootIlumaBlueIcon = (props) => {
    return (
        <Icon width='48' height='48' {...props}>
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M15 7.32136C15 6.94171 15.2128 6.58872 15.5669 6.45183C16.3217 6.16002 17.1422 6 18 6H20.25C24.3921 6 27.75 9.35786 27.75 13.5V34.5C27.75 38.6421 24.3921 42 20.25 42H18C17.1422 42 16.3217 41.84 15.5669 41.5482C15.2128 41.4113 15 41.0583 15 40.6786V40.1422C13.0055 39.203 11.625 37.1748 11.625 34.8242L11.625 13.375C11.625 11.0243 13.0055 8.99614 15 8.05691V7.32136Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M13.875 8.10204C14.2232 7.90062 14.6009 7.74451 15 7.64178L15 40.5574C14.6009 40.4547 14.2232 40.2986 13.875 40.0971L13.875 8.10204Z'
                fill='#FFFDFB'
            />
            <path fillRule='evenodd' clipRule='evenodd' d='M13.875 30.75H11.625V29.25H13.875V30.75Z' fill='#00D1D2' />
            <path
                d='M29.1869 28.3993C28.731 27.6212 28.9921 26.6208 29.7702 26.1648C30.5483 25.7089 31.5487 25.97 32.0047 26.7481L38.2798 37.4566C38.7357 38.2347 38.4746 39.2351 37.6965 39.6911C36.9184 40.147 35.918 39.8859 35.462 39.1078L29.1869 28.3993Z'
                fill='#393E44'
            />
            <ellipse
                cx='26.09'
                cy='19.8809'
                rx='7.78058'
                ry='7.55828'
                transform='rotate(14.63 26.09 19.8809)'
                fill='#FFFDFB'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M27.7754 13.4281C24.0692 12.4606 20.3473 14.5998 19.4231 18.1403C18.4989 21.6808 20.7003 25.3662 24.4066 26.3337C28.1128 27.3012 31.8347 25.162 32.7589 21.6215C33.6831 18.081 31.4817 14.3955 27.7754 13.4281ZM17.7023 17.6911C18.8868 13.1536 23.6154 10.5041 28.2246 11.7073C32.8339 12.9105 35.6642 17.5332 34.4797 22.0707C33.2952 26.6082 28.5666 29.2577 23.9574 28.0545C19.3481 26.8513 16.5178 22.2286 17.7023 17.6911Z'
                fill='#393E44'
            />
            <path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M26.7544 15.8826C26.7453 16.2508 26.4394 16.5419 26.0712 16.5328C25.4262 16.5168 24.7974 16.6676 24.2508 16.9649C23.7045 17.2621 23.2612 17.6941 22.9636 18.2122C22.7802 18.5316 22.3725 18.6418 22.0531 18.4583C21.7338 18.2749 21.6236 17.8673 21.807 17.5479C22.2306 16.8104 22.8562 16.2052 23.6134 15.7932C24.3704 15.3815 25.2311 15.1778 26.1042 15.1994C26.4724 15.2085 26.7635 15.5144 26.7544 15.8826Z'
                fill='#00D1D2'
            />
        </Icon>
    );
};

export default TroubleshootIlumaBlueIcon;
